// Source of truth: physioactivityweb/blogs blob container.
// This hardcoded listing must be kept in sync with the published blobs until a
// live blog-listing API replaces it (POBacklog: blog-listing-api).
// Used by /blog (BlogPage) and the /subscribe directory's Blog filter (SubscribePage).
//
// PROMOTION WARNING: /subscribe is intentionally QA-only (no nav link on prod, but the
// route is reachable by direct URL). On master, SubscribePage.sampleBlogPosts is kept
// empty so /subscribe shows "Coming Soon" on prod. When promoting blog content to
// master, EITHER also promote this file AND accept that the /subscribe Blog filter
// will populate on prod, OR decouple SubscribePage from this module on master and
// leave its sampleBlogPosts empty. See PODecisions 2026-06-14_subscribe-gating-policy.

const blogPosts = [
    /* Not a blob. This one is a static React route — src/WhoWritesPage.js at
       /blog/who-writes-your-programme — listed here so a reader browsing /blog
       can find it, since that is the point of moving it under /blog. It does
       not need syncing with the blobs container; if a blob of the same slug is
       ever published, the static route wins and the blob would be dead. */
    {
        slug: 'the-research',
        title: 'The research behind PhysioActivity',
        category: 'Evidence',
        readTime: '5 min',
        author: 'PhysioActivity',
        date: '2026-09-02',
        excerpt: 'Three claims appear at the bottom of every page on this site. Where each one comes from, and the limits of what it supports.',
    },
    {
        slug: 'who-writes-your-programme',
        title: 'Who writes your programme',
        category: 'How it works',
        readTime: '4 min',
        author: 'PhysioActivity',
        date: '2026-09-02',
        excerpt: 'A registered physiotherapist builds and owns every programme. What the software does, what the clinician decides, and the claims we do not make.',
    },
    // Phase 2B batch 2026-06-25 — 3 remaining drafts (Oct + supply evergreen).
    // See PODecisions 2026-06-25_blog-phase-2b-shipped.
    {
        slug: 'movement-women-health-menopause',
        title: 'Movement and Women\'s Health (incl. Menopause)',
        category: 'Patient Stories',
        readTime: '7 min',
        author: 'PhysioActivity Team',
        date: '2026-06-25',
        excerpt: 'Women\'s MSK has been dismissed and under-researched for decades. Here\'s what we know about adapting movement through hormone shifts, and what the platform can do to help.',
    },
    {
        slug: 'extending-care-beyond-discharge',
        title: 'Extending Care Beyond Discharge',
        category: 'Business',
        readTime: '6 min',
        author: 'PhysioActivity Team',
        date: '2026-06-25',
        excerpt: 'Episode-only care leaks value: the patient who needed a check-in, the prevention work that never happened, the recurrent flare-up. Continuous care is different, and more sustainable than it sounds.',
    },
    {
        slug: 'getting-more-from-your-vald-assessment-kit',
        title: 'Getting More From Your Vald / Assessment Kit',
        category: 'Business',
        readTime: '5 min',
        author: 'PhysioActivity Team',
        date: '2026-06-25',
        excerpt: 'If you\'ve got Vald in the clinic, you\'ve also got idle time between elite bookings. Joining the partner facilities network turns that idle time into routed bookings, and aggregated data.',
    },
    // Phase 1 batch 2026-06-25 — Marketing-CMO blog batch first 3 (Jul / Aug / Sep release).
    // See PODecisions 2026-06-25_blog-batch-cmo-marketing-action, 2026-06-25_insurance-blog-reframe-option-c.
    {
        slug: 'coming-back-to-running-without-injury',
        title: 'Coming Back to Running Without Injury',
        category: 'Patient Stories',
        readTime: '6 min',
        author: 'PhysioActivity Team',
        date: '2026-06-25',
        excerpt: 'The football\'s on. The marathon\'s coming. The first runs back are where most injuries happen. Here\'s how to load it right.',
    },
    {
        slug: 'staying-active-at-a-desk-job',
        title: 'Staying Active at a Desk Job',
        category: 'Patient Stories',
        readTime: '6 min',
        author: 'PhysioActivity Team',
        date: '2026-06-25',
        excerpt: 'Staying active at a desk job isn\'t about a lunchtime gym session. It\'s the micro-movements your phone already knows you\'re skipping.',
    },
    {
        slug: 'starting-your-physio-practice-on-a-platform',
        title: 'Starting Your Physio Practice on a Platform',
        category: 'Business',
        readTime: '7 min',
        author: 'PhysioActivity Team',
        date: '2026-06-25',
        excerpt: 'Newly qualified physios are facing a harder job market than they planned for. Building your own practice on a platform is one path through it.',
    },
    {
        slug: 'how-insurance-claims-work-physioactivity',
        title: 'Building Your Claim Evidence on the PhysioActivity Platform',
        category: 'Business',
        readTime: '6 min',
        author: 'PhysioActivity Team',
        date: '2026-06-25',
        excerpt: 'PhysioActivity does not submit claims, integrate with payers, or chase reimbursements. What it does give you is an evidence package: session records, adherence data, and outcome trends you can put behind your own claim.',
    },
    {
        slug: 'e-consent-and-participant-identity-in-digital-research',
        title: 'E-Consent and Participant Identity in Digital Research',
        category: 'Research',
        readTime: '6 min',
        author: 'PhysioActivity Team',
        date: '2026-06-14',
        excerpt: 'Digital research platforms can run anonymised or identified studies, and the difference is decided by your ethics protocol. Here\'s how the two models work, and when a bulk export needs a DSA.',
    },
    {
        slug: 'nhs-vs-private-vs-subscription-physio',
        title: 'NHS, Private Insurance, or Subscription? A Practical Comparison for MSK Care',
        category: 'Business',
        readTime: '7 min',
        author: 'PhysioActivity Team',
        date: '2026-05-11',
        excerpt: 'Most musculoskeletal care in the UK is delivered through one of three funding models. Each has its strengths, but only one is built for continuous care.',
    },
    {
        slug: 'why-gym-memberships-fail-as-wellbeing-benefit',
        title: 'Why Gym Memberships Fail as a Workplace Wellbeing Benefit',
        category: 'Business',
        readTime: '9 min',
        author: 'PhysioActivity Team',
        date: '2026-05-11',
        excerpt: 'Gym memberships and cycle-to-work schemes sound good on paper, but most employees never use them. We look at where traditional benefits fall short and what works instead.',
    },
    {
        slug: 'from-accelerometer-to-clinical-insight',
        title: 'From Accelerometer to Clinical Insight: How Phone Sensors Become Useful Data',
        category: 'Technology',
        readTime: '9 min',
        author: 'PhysioActivity Team',
        date: '2026-05-11',
        excerpt: 'A modern smartphone already carries the sensors a clinician needs for ongoing MSK monitoring. The harder question is what happens between the raw signal and a useful recommendation.',
    },
    {
        slug: 'data-without-expertise-msk-self-tracking',
        title: 'Data Without Expertise Is Just Numbers',
        category: 'Clinical',
        readTime: '9 min',
        author: 'PhysioActivity Team',
        date: '2026-05-11',
        excerpt: 'Wearables generate enormous amounts of musculoskeletal data. Without professional interpretation, most of it stays as numbers. We look at what changes when an advisor reads the data with you.',
    },
    {
        slug: 'understanding-gait-analysis-ga24blog',
        title: 'Understanding Gait Analysis: How Movement Labs Are Changing Rehabilitation',
        category: 'Clinical',
        readTime: '8 min',
        author: 'PhysioActivity Team',
        date: '2025-05-20',
        excerpt: 'Gait analysis has evolved from a niche research tool to an essential clinical service. Learn how modern movement laboratories use 3D motion capture and force plates to transform rehabilitation outcomes.',
    },
    {
        slug: 'what-is-remote-physiotherapy',
        title: 'What is Remote Physiotherapy?',
        category: 'Clinical',
        readTime: '5 min',
        author: 'PhysioActivity Team',
        date: '2025-01-15',
        excerpt: 'Remote physiotherapy is transforming how patients access musculoskeletal care. Learn what it involves, how sessions work, and whether it could be right for you.',
    },
    {
        slug: '5-signs-you-need-an-msk-assessment',
        title: '5 Signs You Need an MSK Assessment',
        category: 'Patient Stories',
        readTime: '4 min',
        author: 'PhysioActivity Team',
        date: '2025-01-08',
        excerpt: 'Not sure whether your pain warrants a physiotherapy assessment? Here are five signs that it might be time to see a musculoskeletal specialist.',
    },
    {
        slug: 'future-of-wearables-in-rehab',
        title: 'The Future of Wearables in Rehab',
        category: 'Technology',
        readTime: '7 min',
        author: 'PhysioActivity Team',
        date: '2024-12-20',
        excerpt: 'Wearable technology is moving beyond step counting. Discover how IMUs, smart fabrics, and AI-driven analytics are transforming rehabilitation and clinical outcomes.',
    },
    /* "Case Study: Corporate Wellness ROI" unpublished 2026-08-31 (CMO QA review,
       QA-02). It asserted measurable ROI through reduced absence and improved
       productivity, and called itself a real-world case study — which on our own
       blog reads as ours, when we have no customers and no deployment evidence.
       Held pending clinical review. If the underlying article is about someone
       else's programme it may return with the subject named in the title and
       standfirst, but not as it was written. */
    {
        slug: 'how-advisor-subscriptions-work',
        title: 'How Advisor Subscriptions Work',
        category: 'Technology',
        readTime: '5 min',
        author: 'PhysioActivity Team',
        date: '2024-11-15',
        excerpt: 'An advisor subscription on PhysioActivity is a recurring relationship between patient and clinician. Here\'s how the Bronze/Silver/Gold tiers, durations, and billing actually work.',
    },
];

export const blogCategories = ['All', 'Business', 'Clinical', 'Patient Stories', 'Research', 'Technology'];

export default blogPosts;
